
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 发票列表
export function getInvoiceList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/invoices',
    method: 'GET',
    params: parameter
  })
}
// 获取单个收票/开票详情
export function getInvoice (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/invoice',
    method: 'GET',
    params: parameter
  })
}

// 发票详情
export function getInvoiceDetail (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/receivablesPaymentInvoice/detail',
    method: 'GET',
    params: parameter
  })
}

// 获取收据信息
export function getRPInfoList (query) {
  return axios.request({
    url: sysInfo.apiRemote + `/receivablesPaymentInvoice/getRPInfo`,
    params: query,
    method: 'get'
  })
}

// 新增||编辑开票数据
export function controlInvoice (query) {
  return axios.request({
    url: sysInfo.apiRemote + `/invoice`,
    data: query,
    method: 'POST'
  })
}

// 锁定发票
export function lockInvoice (query) {
  return axios.request({
    url: sysInfo.apiRemote + `/invoice/lock`,
    params: query,
    method: 'PUT'
  })
}

// 删除发票
export function deleteInvoice (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/invoice',
    method: 'DELETE',
    params: parameter
  })
}
// 开票/收票附件删除
export function deleteFile (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/invoice/files`,
    method: 'DELETE',
    params: parameter
  })
}
// 收票关联发票附件打包下载接口开发
export function downloadInvoiceFile (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/invoice/files/${parameter}`,
    responseType: 'blob',
    method: 'GET'
  })
}
// 获取销售合同下拉列表数据
export function getContractsSell (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/contract/sale/standard`,
    method: 'GET',
    params: parameter
  })
}
// 获取收款比例不超过100%的销售合同列表数据
export function getContractsSellPercentage (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/contract/sale/collection`,
    method: 'GET',
    params: parameter
  })
}
// 获取采购合同下拉列表数据
export function getAllPurchaseContractLists (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/purchase/receipts',
    method: 'GET',
    params: parameter
  })
}
// 获取甲方下拉列表数据
export function getProprietors (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/proprietors`,
    method: 'GET',
    params: parameter
  })
}
// 获取供应商下拉列表数据
export function getSuppliers (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/suppliers`,
    method: 'GET',
    params: parameter
  })
}
// 获取关联收款下拉列表数据
export function getCollection (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/payments`,
    method: 'GET',
    params: parameter
  })
}
